// extracted by mini-css-extract-plugin
export var dateOfConditions = "index-module--dateOfConditions--aa+Dr";
export var sectionWrapper = "index-module--section-wrapper--w2Fzl";